import React, { MutableRefObject, useEffect, useRef, useState } from "react";

import { FolderItemComponentPropsState } from "./folder-item.types";

import SettingChatFolderIcon from "~/view/assets/setting-chat-folder";

const ChatFolderItem: React.FC<FolderItemComponentPropsState> = (props: FolderItemComponentPropsState) => {
  const [countNotifications, setCountNotifications]: [number, React.Dispatch<React.SetStateAction<number>>] =
    useState<number>(0);

  const delayRef: MutableRefObject<number | null> = useRef<number | null>(null);

  useEffect(() => {
    if (props.folderItem.id !== "All") {
      if (delayRef.current !== null) {
        clearTimeout(delayRef.current);
      }

      delayRef.current = window.setTimeout(() => {
        const sumNotifications: number = props.chats.reduce((total, chat) => {
          if (
            chat.folders &&
            chat.folders?.length > 0 &&
            chat.notifications &&
            chat.notifications > 0 &&
            chat.folders.some(folder => folder.id === props.folderItem.id)
          ) {
            return total + chat.notifications;
          }
          return total;
        }, 0);

        setCountNotifications(sumNotifications);
      }, 500);

      return (): void => {
        if (delayRef.current !== null) {
          clearTimeout(delayRef.current);
        }
      };
    }
  }, [props.chats]);

  return (
    <div
      className={props.className}
      onClick={(): void => {
        if (
          props.currentFolder == null &&
          props.handleSwitchToArchivedFolder &&
          typeof props.isArchivedFolder == "boolean" &&
          props.folderItem.id == "All"
        ) {
          props.handleSwitchToArchivedFolder(!props.isArchivedFolder);
          props.handleChangeCurrentFolder(null);
        }

        if (props.currentFolder?.id !== props.folderItem.id) {
          if (props.isArchivedFolder === true) {
            props.handleSwitchToArchivedFolder(!props.isArchivedFolder);
          }
          props.handleChangeCurrentFolder(props.folderItem.id == "All" ? null : props.folderItem);
        }
      }}
    >
      <span>{props.folderItem.title}</span>
      {props.folderItem.notifications !== undefined &&
        props.folderItem.notifications > 0 &&
        props.folderItem.id == "All" && <span>{props.folderItem.notifications}</span>}

      {props.folderItem.id !== "All" && countNotifications > 0 && <span>{countNotifications}</span>}

      {props.folderItem.id !== "All" && (
        <div
          className={props.classNameSetting}
          onClick={(): void => props.handleChatSelectFolderSettingModalIsOpen(true)}
        >
          <SettingChatFolderIcon />
        </div>
      )}
    </div>
  );
};

export default ChatFolderItem;
